import { render, staticRenderFns } from "./FilterSummaryOptionHeron.vue?vue&type=template&id=6fbb932f&"
import script from "./FilterSummaryOptionHeron.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryOptionHeron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports